<ng-container *ngIf="categories$ | async as categories">
  <ng-container *ngIf="categories?.length > 0; else noCategories">
    <span *ngFor="let category of categories; last as isLast">{{ category.name }}{{ isLast ? '' : ', ' }}</span>
  </ng-container>
  <ng-template #noCategories>
    <span *ngIf="placeholder" class="placeholder">{{ placeholder }}</span>
  </ng-template>
</ng-container>
